<template>

  <div align="center" v-loading="loading">
    <el-card class="info box-card">
      <div slot="header" class="clearfix">
        <span>会员信息</span>
      </div>
      <div class="text item"> 会员昵称: {{userInfo.name}}</div>
      <div class="text item"> 会员姓名: {{userInfo.sex}}</div>
      <div class="text item"> 会员生日: {{userInfo.birthday}}</div>
      <div class="text item"> 手机号码: {{userInfo.mobile_phone}}</div>
    </el-card>

    <el-button type="danger" style="width: 320px;" @click="logoutHandler"> 退出登录</el-button>
  </div>
</template>

<script>
  import {APIRequest} from '@/api/api';

  export default {
    data() {
      return {
        loading: true,
        userInfo: {}
      };
    },
    created() {
      this.fetchDetail();
    },
    methods: {
      fetchDetail() {
        let self = this;
        let params = {};
        self.loading = true;
        APIRequest('getUserData', params, true).then(res => {
          self.loading = false;

          self.userInfo = res.data;
        }, err => {
          self.loading = false;
        });
      },
      logoutHandler () {
        let self = this;
        let params = {};
        APIRequest('logout', params, true).then(res => {
          self.$router.push('/');
        }, err => {});
      }
    }
  }
</script>

<style>
  .info {
    position: relative;
    text-align: left;
    min-width: 1040px;
    max-width: 1300px;
    margin: 20px 200px 20px 200px;
    padding: 0;
  }

  .text {
    font-size: 14px;
  }

  .item {
    margin-bottom: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Member/Info.vue